<template>
  <CheckPanel>
    <template slot="title">Ben je ouder dan 25 jaar?</template>
    <template slot="buttons">
      <CheckPanelButton correct @click.native="vote(true)">
        Ja
      </CheckPanelButton>
      <CheckPanelButton @click.native="vote(false)">
        Nee
      </CheckPanelButton>
    </template>
  </CheckPanel>
</template>

<script>
import { EventBus } from '@/EventBus'
import { CheckPanel, CheckPanelButton } from '@/components/check-panel'

export default {
  name: 'AgeCheck',
  methods: {
    vote (bool) {
      EventBus.$emit('isOldEnough', bool)
    }
  },
  components: {
    CheckPanel,
    CheckPanelButton
  }
}
</script>
